"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetState_1 = require("auto-widget-framework/src/Model/WidgetState");
class PXWidgetState extends WidgetState_1.WidgetState {
    getValuation() {
        return this.get("valuation");
    }
    setValuation(valuation) {
        this.set("valuation", valuation);
        return this;
    }
    getVehicle() {
        return this.get("vehicle");
    }
    setVehicle(vehicle) {
        this.set("vehicle", vehicle);
        return this;
    }
    setValuationPrice(price) {
        this.set("valuationPrice", price);
        return this;
    }
    getValuationPrice() {
        return this.get("valuationPrice");
    }
    resetState() {
        this.state = {};
    }
}
exports.default = PXWidgetState;
